import React from "react";
import { useSelector } from "react-redux";
import { homePageSelector } from "store/selectors/HomePage";
import { Page } from "components/core/Page";
import { Hero } from "components/brand/Hero";
import {
	ThreeSimpleStepsSection,
	WeMakeStorageEasySection,
	HereForYouSection,
	CustomersSayingSection,
	FeaturedCities
} from "components/landing";

import "./HomePage.scss";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";
import { PAGE_TYPES } from "@sparefoot/tracking-events";

function HomePage() {
	const { trackingPixelUrl, meta } = useSelector(homePageSelector);
	usePageViewTracking(PAGE_TYPES.HOME_PAGE);

	return (
		<Page
			className="home-page"
			title={meta.title}
			pageType={PAGE_TYPES.HOME_PAGE}
			trackingPixelUrl={trackingPixelUrl}
			description={meta.description}
			canonical={meta.canonical}
		>
			<Hero />
			<ThreeSimpleStepsSection />
			<CustomersSayingSection />
			<WeMakeStorageEasySection />
			<HereForYouSection />
			<FeaturedCities />
		</Page>
	);
}

export default HomePage;
